import { MessageIcons } from '@/app/chat/_common/message-icons'
import { MessageOutput } from '@/app/chat/_common/message-output'
import { useTurnParsed } from '@/app/chat/_common/use-turn-parsed'
import { type TabTurn } from '../types'

// =============================================================================
// TURN TAB CONTENT COMPONENTS
// =============================================================================

/**
 * Content for turn tabs - displays message output with interactive elements
 */
export const TurnOutputTabContent = ({ tab }: Readonly<{ tab: TabTurn }>) => {
  const { outputMessage } = useTurnParsed({ turnId: tab.turnId, workflowId: tab.workflowId })

  return (
    <div className='relative h-full'>
      <MessageOutput
        content={outputMessage?.messageContent.content ?? []}
        title={tab.title}
        {...(outputMessage && {
          renderIcons: (options) => (
            <div className='sticky bottom-0 w-full bg-neutral-25'>
              <MessageIcons
                workflowId={tab.workflowId}
                messageId={outputMessage.messageId}
                feedback={outputMessage.feedback}
                {...options}
              />
            </div>
          ),
        })}
      />
    </div>
  )
}
